<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Profil</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
			<div class="px-2">/</div>
			<div>Profil</div>
		</div>
		<div class="mt-5">
			<v-row v-if="loading">
				<v-col cols="12" sm="4" md="3" xl="2">
					<v-card class="elevation-0 rounded-lg">
						<vcl :height='500'>
							<rect x="80" y="50" rx="140" ry="140" width="240" height="240" />
							<rect x="110" y="330" rx="2" ry="2" width="180" height="25" />
							<rect x="125" y="370" rx="2" ry="2" width="150" height="25" />
							<rect x="150" y="430" rx="2" ry="2" width="100" height="25" />
						</vcl>
					</v-card>
				</v-col>
				<v-col cols="12" sm="8" md="9" xl="6">
					<v-card class="elevation-0 rounded-lg">
						<vcl :height='280'>
							<rect x="20" y="20" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="20" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="65" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="65" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="110" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="110" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="155" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="155" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="200" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="200" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="245" rx="2" ry="2" width="360" height="12" />
						</vcl>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<v-row v-if="!loading">
					<v-col cols="12" sm="4" md="3" xl="2">
						<v-card class="pa-5 elevation-0 rounded-lg">
							<div class="bg-card-profile">
								<v-img src="/assets/icon/bg-profile-picture.svg"></v-img>
							</div>
							<v-row class="mt-3">
								<v-col cols="12">
									<v-row justify="center">
										<v-col cols="7" sm="9" class="px-0 py-5">
											<div class="text-center" >
												<v-img height="165" width="165" class="user-img mx-auto rounded-pill" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
												<v-file-input hide-input accept="image/png, image/jpeg, image/jpg" prepend-icon="mdi-camera" clearable hint="Ukuran maksimal file 2Mb" class="icon-upload-image" width="20" @change="handleFileUpload($event)"></v-file-input>
											</div>
										</v-col>
									</v-row>
									<div class="pt-5 text-center">
										<div class="font-size-14 cl-primary font-weight-600">{{ myProfile.member_name }}</div>
										<div class="font-size-11 cl-secondary">{{ myProfile.network_code }}</div>
									</div>

									<v-card
										outlined
										class="mt-4 py-1"
										v-if="myProfile.network_type"
									>

										<div class="d-flex align-center justify-center">
											<div class="my-2">
												<v-img width="48" style="height: auto;max-width: 100%;" class="mr-3" :src="getNetworkTypeBadge(myProfile.network_type)"></v-img>
											</div>
											<div class="font-size-10 font-size-xs-10 font-weight-600 d-flex flex-column">
												<div class="cl-secondary">Kemitraan Anda</div>
												<!-- <div class="text-uppercase" :style="{color: getNetworkTypeColor(myProfile.network_type)}">{{ (myProfile.network_type === 'gold') ? 'Gold Star' : (myProfile.network_type === 'repeat_order') ? 'Silver' : myProfile.network_type }}</div> -->
												<div class="text-uppercase" :style="{color: getNetworkTypeColor(myProfile.network_type)}">{{ getNetworkTypeText(myProfile.network_type) }}</div>
											</div>
										</div>
									</v-card>

									<template v-if="myProfile.network_type == 'silver' && myProfile.network_type == 'gold' && myProfile.network_type !== 'basic' && myProfile.network_type !== 'pramitra'">
										<v-row class="mt-2">
											<v-col cols="12" sm="12" class="pt-1">
													<v-btn
														color="primary"
														outlined
														block
														@click="gotoUpgrade"
													><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade</v-btn>
											</v-col>
										</v-row>
									</template>

									<template v-if="myProfile.network_type == 'pramitra'">
										<v-row class="mt-2">
											<v-col cols="12" sm="12" class="pt-1">
													<v-btn
														color="warning"
														outlined
														block
														@click="gotoActivation"
													><v-icon dense class="mr-1">mdi-account-reactivate-outline</v-icon>Aktivasi Akun</v-btn>
											</v-col>
										</v-row>
									</template>
								</v-col>
							</v-row>
							<template v-if="Object.values(myProfile).length > 0"><upgradedate-alert :myProfile="myProfile" :networkType="myProfile.network_type"></upgradedate-alert></template>
						</v-card>
					</v-col>
					<v-col cols="12" sm="8" md="9" xl="6" class="pt-sm-0">
						<v-tabs grow background-color="green lighten-5" class="no-slider bg-light-primary">
							<v-tab @click="switchProfile">Data Profil</v-tab>
							<v-tab @click="switchBank">Data Bank</v-tab>
						</v-tabs>
						<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
							<div class="pt-5" v-if="Object.values(myProfile).length > 0 && showProfile">
								<ProfileData :province="provinces" :city="cities" :data="myProfile"></ProfileData>
							</div>
						</v-scroll-x-reverse-transition>
						<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
							<div class="pt-5" v-if="!showProfile">
								<BankData :list="listBank" :data="myBank"></BankData>
							</div>
						</v-scroll-x-transition>
					</v-col>
				</v-row>
			</v-scroll-x-reverse-transition>
		</div>
	</v-col>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ProfileData from './components/ProfileData';
import BankData from './components/BankData';
import upgradeDateAlert from '@/components/upgradeDateAlert'

export default {
	components: {
		ProfileData, BankData, 'upgradedate-alert': upgradeDateAlert
	},
	data() {
		return {
			showProfile: true,
			loading: true,
			isActiveMember: false,
			kemitraan: [
				{
					type: 'pramitra',
					color: '#999',
					belanja: '0',
					badges: '/assets/icon/pramitra.svg',
					classText: 'mitra-pra'
				},
				{
					type: 'basic',
					color: '#01400c',
					belanja: '0',
					badges: '/assets/icon/basic.svg',
					classText: 'mitra-basic'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				},
				{
					type: 'business',
					color: '#bf1404',
					belanja: '13.000.000',
					badges: '/assets/icon/business.svg',
					classText: 'mitra-business'
				}
			],
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('option', ['provincesCities', 'provinces', 'cities', 'listBank']),
		...mapState('profile', ['myProfile', 'myBank']),
	},
	methods: {
		...mapActions('option', ['getProvince', 'getCity', 'getBank']),
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra', 'getBankMitra', 'getBankPramitra', 'changeImageMitra', 'changeImagePramitra']),
		...mapMutations('profile', ['clearDataUser']),

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		gotoActivation() {
			// this.$router.push({name: 'aktivasi'})
			this.$router.push({name: 'aktivasi-mitra', query: { id: this.myProfile.member_id }})
		},

		switchProfile() {
			this.showProfile = true
		},

		switchBank() {
			this.showProfile = false
		},

		getNetworkTypeBadge(Nettype) {
			// if(type === 'repeat_order') type = 'silver'
			// const netType = this.kemitraan.find(x => x.type === type)
			// return netType.badges

			let selectType = ''
			if (Nettype) {
				let condition = Nettype.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = Nettype.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = Nettype.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_name
				else if (condition.length > 0) selectType = condition[0].rank_type_name
				else if (condition3.length > 0) selectType = condition3[0].rank_type_name
				else selectType = 'pramitra'

				let getTypes = this.kemitraan.find(x => x.type === selectType)
				return getTypes.badges
			}
		},

		getNetworkTypeColor(Nettype) {
			// if(type === 'repeat_order') type = 'silver'
			// const netType = this.kemitraan.find(x => x.type === type)
			// return netType.color

			let selectType = ''
			if (Nettype) {
				let condition = Nettype.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = Nettype.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = Nettype.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_name
				else if (condition.length > 0) selectType = condition[0].rank_type_name
				else if (condition3.length > 0) selectType = condition3[0].rank_type_name
				else selectType = 'pramitra'

				let getTypes = this.kemitraan.find(x => x.type === selectType)
				return getTypes.color
			}
		},

		getNetworkTypeText(Nettype) {
			// (myProfile.network_type === 'diamond') ? 'Platinum' : (myProfile.network_type === 'repeat_order') ? 'Silver' : (myProfile.network_type == 'basic') ? 'Mikro' : myProfile.network_type
			let selectType = ''
			if (Nettype) {
				let condition = Nettype.filter(p => p.rank_type_plan_activity == "Reguler")
				let condition2 = Nettype.filter(p => p.rank_type_plan_activity == "Business")
				let condition3 = Nettype.filter(p => p.rank_type_plan_activity == "Mikro")

				if (condition2.length > 0) selectType = condition2[0].rank_type_plan_activity
				else if (condition.length > 0) selectType = condition[0].rank_type_plan_activity
				else if (condition3.length > 0) selectType = condition3[0].rank_type_plan_activity
				else selectType = 'pramitra'

				return selectType
			}
		},

		handleFileUpload(event) {
			// this.loadingProcess = true
			let formData = new FormData();
			formData.append('image_profile', event);

			if (this.isActiveMember) {
				this.changeImageMitra(formData).then(() => {
					this.getProfileMitra()
				})
			} else {
				this.changeImagePramitra(formData).then(() => {
					this.getProfilePramitra()
				})
			}
		},
		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0 || data.network_type == 'pramitra') this.isActiveMember = false
			else this.isActiveMember = true
		},
		async getData() {
			this.loading = await true
			const authData = await localStorage.getItem('mlmcore-vo-auth-data');
			const data = await JSON.parse(authData)

			await this.getProvince()
			await this.getBank()

			await this.checkMemberActivation(data)
			if (this.isActiveMember) {
				await this.getProfileMitra().then(() => {
					if ( this.myProfile.member_province_id > 0 ) {
						this.getCity({province_id: this.myProfile.member_province_id})
					}
				})
				await this.getBankMitra()
			} else {
				// await this.getProfilePramitra().then(() => {
				// 	if ( this.myProfile.member_province_id > 0 ) {
				// 		this.getCity({province_id: this.myProfile.member_province_id})
				// 	}
				// })
				await this.getProfileMitra().then(() => {
					if ( this.myProfile.member_province_id > 0 ) {
						this.getCity({province_id: this.myProfile.member_province_id})
					}
				})
				// await this.getBankPramitra()
				await this.getBankMitra()
			}

			this.loading = await false
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Profil`)
		this.getData()
	},
	beforeDestroy() {
		this.clearDataUser()
	}
};
</script>